import { render, staticRenderFns } from "./MaintenancesTable.vue?vue&type=template&id=5c85e7c9&"
import script from "./MaintenancesTable.vue?vue&type=script&lang=js&"
export * from "./MaintenancesTable.vue?vue&type=script&lang=js&"
import style0 from "./MaintenancesTable.vue?vue&type=style&index=0&id=5c85e7c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports